import { TUpdateUserProfileInfoParams } from 'types/services';
import { m8API } from 'services/production/m8';
import { normalizeClientProfileInfo } from 'services/production/utils/normalizeClientProfileInfo';

export const updateUserProfileInfo = async (
  params: TUpdateUserProfileInfoParams
) => {
  const { profileInfo } = params;

  const userProfileUpdate = normalizeClientProfileInfo(
    profileInfo
  ).toM8UserProfileUpdate();

  await m8API.user.updateQuestionnaireInfo({ userProfileUpdate });
};
